/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiAuthLoginIcon24Regular = forwardRef('ArrowUiAuthLoginIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M7.25 3A.75.75 0 0 1 8 2.25h8A3.75 3.75 0 0 1 19.75 6v12A3.75 3.75 0 0 1 16 21.75H8a.75.75 0 0 1 0-1.5h8A2.25 2.25 0 0 0 18.25 18V6A2.25 2.25 0 0 0 16 3.75H8A.75.75 0 0 1 7.25 3Z" }),
        React.createElement("path", { d: "m12.275 12.752-3.641 3.642a.75.75 0 0 0 1.06 1.06l3.928-3.927a2.156 2.156 0 0 0 0-3.05L9.694 6.55a.75.75 0 0 0-1.06 1.06l3.641 3.642H1a.75.75 0 0 0 0 1.5h11.275Z" })));
});
